import { TableChangeState } from 'react-bootstrap-table-next';
import {
  RouteItemStateType,
  CollectItemStateTypes,
} from '~globals/types/enums';
import { ItemFilterV2Base } from '~services/item/types';

export const ITEM_KEY_ID = 'itemId';

export const DEFAULT_PAGINATION: Omit<
  TableChangeState<unknown>,
  'data' | 'filters' | 'cellEdit'
> = {
  page: 1,
  sizePerPage: 50,
  sortField: 'maxDeliveryDateTime',
  sortOrder: 'desc',
};

export const DEFAULT_ROUTE_ITEM_STATES: RouteItemStateType[] = [
  RouteItemStateType.New,
];

export const DEFAULT_COLLECT_ITEM_STATES: CollectItemStateTypes[] = [
  CollectItemStateTypes.ToValidate,
];

export const DEFAULT_FILTERS_PAYLOAD: ItemFilterV2Base = {
  routeCode: null,
  maxDeliveredDateTimeFrom: null,
  maxDeliveredDateTimeTo: null,
  includeWithoutMaxDeliveryDatetime: null,
  dateFrom: null,
  dateTo: null,
  finalizedDateTimeFrom: null,
  finalizedDateTimeTo: null,
  unit1GraterThan: null,
  unit1LowerThan: null,
  unit2GraterThan: null,
  unit2LowerThan: null,
  priceGraterThan: null,
  priceLowerThan: null,
  vehiclesId: null,
  driversId: null,
  serviceTypeList: null,
  zonesId: null,
  assignedUserId: null,
  sourceImportTypeIds: null,
  routeItemStateTypesId: DEFAULT_ROUTE_ITEM_STATES,
  pickingStateTypeId: null,
  includeCollectedItems: null,
  collectItemStateTypesId: DEFAULT_COLLECT_ITEM_STATES,
  giverCollectItemStateTypesId: [],
};
